import { useEffect, useState } from "react";

import { FieldFilterType } from "../../../base/types";
import moment from "moment";
import { useAuth } from "../../../../modules/auth";
import { useLazyReadMultipleQuery } from "../../../services/data/tableDataApi";

export const useGetNotificationEvents = () => {
    const { user, siteId } = useAuth();
    const [getRecords] = useLazyReadMultipleQuery();
    const [notificationIds, setNotificationIds] = useState<string[]>([]);
    const today = moment().format("YYYY-MM-DD");

    useEffect(() => {
        getNotificationIds();
        // eslint-disable-next-line
    }, [user]);

    const getNotificationIds = (): Promise<string[]> => {

        return getRecords({
            userId: user?.contactId || user?.entityId,
            portalId: siteId || '',
            tableId: "slcm_notificationevent",
            fieldList: ["slcm_startdate", "slcm_enddate", "slcm_notification", "slcm_student"],
            filters: [{
                group: 0, filters: [
                    { field: "slcm_student", type: FieldFilterType.Const, value: `${user?.entityId || user?.contactId}` },
                    { field: "slcm_startdate", type: FieldFilterType.Filter, value: `<= '${today}'` },
                    { field: "slcm_enddate", type: FieldFilterType.Filter, value: `>= '${today}'` }
                ]
            }]
        })
            .unwrap()
            .then((data) => {
                if (data.records.length > 0) {
                    const ids = data.records.map(record => record["slcm_notification"]);
                    setNotificationIds(ids);
                    return Promise.resolve(ids);
                }

                return Promise.reject('No active notifications found.');
            });
    };

    return { notificationIds };
}
